<template>
	<a-row :gutter="[6, 6]">
		<a-col :span="24" class="d-flex align-items-center">
			<div class="text-uppercase text-dark">
				<strong>Account Groups</strong>
			</div>
			<a-tooltip placement="top" class="ml-auto">
				<template slot="title">
					<span>Create Group</span>
				</template>
				<a-button
					type="link"
					class="btn btn-sm btn-light"
					@click="() => (modalGroup = true)"
				>
					<a-icon type="plus" />
				</a-button>
			</a-tooltip>
		</a-col>
		<a-col :span="24">
			<a-row :gutter="[6, 6]">
				<a-col
					:span="24"
					v-for="(group, index) in getAccountGroups"
					:key="index"
				>
					<div class="item p-2 d-flex border-gray-2">
						<span>{{ group.name }} </span>
						<a-button
							type="link"
							size="small"
							class="ml-auto text-danger"
							@click="handleDeleteGroup(group)"
						>
							<a-icon type="delete" />
						</a-button>
					</div>
				</a-col>
			</a-row>
		</a-col>
		<a-modal
			title="New Group"
			:visible="modalGroup"
			@ok="handleOkGroup"
			:confirm-loading="confirmLoading"
			@cancel="handleCancelGroup"
		>
			<a-form
				:form="form"
				:label-col="{ span: 4 }"
				:wrapper-col="{ span: 20 }"
				class="p-2"
			>
				<a-form-item label="Name">
					<a-input
						v-decorator="[
							'name',
							{
								rules: [
									{
										required: true,
										message: 'Required field',
									},
								],
							},
						]"
						placeholder="Group Name"
					/>
				</a-form-item>
			</a-form>
		</a-modal>
	</a-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ACCOUNT_GROUP as GROUP_ACTIONS } from '@/store/actions'

export default {
	components: {},
	data: function() {
		return {
			form: this.$form.createForm(this),
			loading: true,
			modalGroup: false,
			confirmLoading: false,
		}
	},
	created() {
		this.loadGroups().then(() => {
			this.loading = false
		})
	},
	computed: {
		...mapGetters(['getAccountGroups']),
	},
	methods: {
		handleDeleteGroup(group) {
			this.$confirm({
				title: 'Delete the following Group?',
				content: group.name,
				okText: 'Yes',
				okType: 'success',
				cancelText: 'No',
				onOk: () => {
					this.deleteGroup(group)
				},
			})
		},

		handleOkGroup(e) {
			this.form.validateFields((err, values) => {
				if (!err) {
					this.confirmLoading = true
					this.createGroup({
						name: values.name,
					})
						.then(group => {
							this.form.resetFields()
							this.$notification.success('Group Created')
						})
						.catch(e => {
							this.$notification.error('Whoops something was broke')
						})
						.finally(() => {
							this.modalGroup = false
							this.confirmLoading = false
						})
				}
			})
		},
		handleCancelGroup() {
			this.modalGroup = false
			this.form.resetFields()
		},
		handleCreateGroup() {},
		...mapActions({
			createGroup: GROUP_ACTIONS.CREATE,
			loadGroups: GROUP_ACTIONS.LIST,
			deleteGroup: GROUP_ACTIONS.DELETE,
		}),
	},
}
</script>
